module.exports = __webpack_public_path__ + "static/img/t-3.893adc2a.png";